import { render, staticRenderFns } from "./PermissionSelector.vue?vue&type=template&id=7497dfaa&scoped=true&"
import script from "./PermissionSelector.vue?vue&type=script&lang=ts&"
export * from "./PermissionSelector.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionSelector.vue?vue&type=style&index=0&id=7497dfaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7497dfaa",
  null
  
)

export default component.exports